module.exports = __webpack_public_path__ + "static/c23.ab374540.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/hair-color/c23.jpg
// module id = 542
// module chunks = 255811786354371